import UTILITY_API from "../utility_api";

const getActivityCodesForReference = (reference, query) => {
  const matchingObjects = reference.filter((element) =>
    query.includes(element.reference_letters_required)
  );

  const activityCodes = matchingObjects.map((obj) => ({
    reference_letters_required: obj.reference_letters_required,
    activity_codes: obj.activity_codes,
  }));

  return activityCodes.length > 0 ? activityCodes : null;
};

const fetchReference = async (reference_option) => {
  try {
    const reference_letters = await fetch(UTILITY_API + "/reference_letters");
    if (!reference_letters.ok) {
      throw new Error(`First API call failed: ${reference_letters.statusText}`);
    }
    const reference_letters_data = await reference_letters.json();

    const activityCodes = getActivityCodesForReference(
      reference_letters_data,
      reference_option
    );

    if (activityCodes) {
      const flattenedActivityCodes = activityCodes.flatMap(
        (obj) => obj.activity_codes
      );
      let updateDataQuery = {
        activitycodes: flattenedActivityCodes.join(","),
      };
      return updateDataQuery;
    }
  } catch (error) {
    console.error("Failed to fetch data:", error);
  }
};

export const handleReferenceLettersHelper = async (reference) => {
  let updateDataQuery = await fetchReference(reference);
  return updateDataQuery;
};
